module.exports = __webpack_public_path__ + "img/community-selected.9a1f14bf.png";